<template>
  <header class="header">
    <div class="header__content">
      <div>
        <img
          class="header__logo-desktop"
          alt="logo-decktop"
          src="../../assets/logo.svg"
        />
      </div>

      <div class="header__btn-group">
        <button
          v-if="!isAuth"
          class="btn btn-primary header__btn"
          @click="showLoginModal()"
        >
          <span>Авторизация</span>
        </button>

        <button
          v-if="!isAuth"
          class="header__icon-btn"
          @click="showLoginModal()"
        >
          <iconProfile class="header__icon" />
        </button>

        <button
          v-if="!isAuth"
          class="btn btn-primary header__btn"
          @click="showRegistrationModal()"
        >
          <span>Регистрация</span>
        </button>

        <button
          v-if="!isAuth"
          class="header__icon-btn"
          @click="showRegistrationModal()"
        >
          <iconAddUser class="header__icon" />
        </button>
      </div>
    </div>
  </header>

  <LoginModal
    ref="loginModalRef"
    @openRegistration="showRegistrationModal"
    @resetPass="showResetPassModal()"
  />
  <RegistrationModal
    ref="registrationModalRef"
    @click="showRegistrationModal()"
    @openAuthModal="showLoginModal()"
  ></RegistrationModal>

  <ResetPasswordModal
    ref="resetPasswordRef"
    @openAuthModal="showLoginModal()"
    @openRegModal="showRegistrationModal()"
  ></ResetPasswordModal>
</template>

<script lang="ts">
import { defineComponent, ref, computed } from 'vue';
import LoginModal from '@/components/header/LoginModal.vue';
import RegistrationModal from '@/components/header/RegistrationModal.vue';
import ResetPasswordModal from '@/components/header/ResetPasswordModal.vue';
import { useAuthStore } from '@/store/authStore';
import { useRouter } from 'vue-router';
import type { userType, modalType } from '@/types/common';
import iconProfile from '@/components/icons/iconProfile.vue';
import iconAddUser from '@/components/icons/iconAddUser.vue';

export default defineComponent({
  name: 'HeaderComponent',
  components: {
    LoginModal,
    RegistrationModal,
    ResetPasswordModal,
    iconProfile,
    iconAddUser,
  },
  setup() {
    const router = useRouter();
    const store = useAuthStore();
    const isAuth = computed((): userType | null => store.userStore);

    const showLoginModal = () => {
      if (loginModalRef.value) {
        loginModalRef.value.isOpen = true;
      }
    };
    const showRegistrationModal = () => {
      router.push({ name: 'HomePage' });
      store.logout();
      if (registrationModalRef.value) {
        registrationModalRef.value.isOpen = true;
      }
    };

    const showResetPassModal = () => {
      router.push({ name: 'HomePage' });
      store.logout();
      if (resetPasswordRef.value) {
        resetPasswordRef.value.isOpen = true;
      }
    };

    const logout = () => {
      router.push({ name: 'HomePage' });
      store.logout();
    };

    const loginModalRef = ref<modalType | null>(null);
    const registrationModalRef = ref<modalType | null>(null);
    const resetPasswordRef = ref<modalType | null>(null);

    return {
      loginModalRef,
      registrationModalRef,
      resetPasswordRef,
      showResetPassModal,
      showLoginModal,
      logout,
      showRegistrationModal,
      isAuth,
    };
  },
});
</script>

<style lang="scss" scoped>
.header {
  background-color: var(--background-2);
  max-width: 1920px;
  margin: 0 auto;
  padding-left: 40px;
  padding-right: 40px;
  &__content {
    height: 70px;
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
  &__logo {
    display: flex;
    align-items: center;
    height: 100%;
    column-gap: 8px;
    user-select: none;
    margin: 0;
    &-desktop {
      display: inline-block;
      width: 100%;
    }
  }
  &__btn-group {
    display: flex;
    height: 100%;
    align-items: center;
    column-gap: 16px;
  }
  &__btn {
    font-size: 16px;
    display: flex;
    align-items: center;
    column-gap: 8px;
    display: inline-block;
    @media (max-width: 700px) {
      display: none;
    }
  }
  &__icon-btn {
    display: none;
    align-items: center;
    justify-content: center;
    width: 40px;
    height: 40px;
    background-color: var(--primary-btn);
    border: 1px solid var(--primary);
    border-radius: 8px;
    cursor: pointer;
    transition: all 0.3s ease;
    @media (min-width: 490px) and (max-width: 700px) {
      display: flex;
    }
  }
  &__icon {
    &:hover {
      color: var(--icon-hover);
    }
  }
}
</style>
